export default __webpack_public_path__ + "static/pyfonts-f4690cf631868f27d6213d5a6f82fa85.png";